import api from '@/os/APIs/walletAPI';

export default {
  install: (app) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$wallet = api;
  },
};
